// An old weekly coaching reminder's link (/coaching/{period}?do=off|stay). Coaching mode is
// retired (ADR 0007, 2026-10-25): listening needs nothing turned on, so the link only says so.
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { Crumbs } from "../../../components/Crumbs";
import { Card, PageHeader } from "../../../components/ui";
import { level } from "../../../lib/crumbs";
import { Link } from "../../../lib/navigate";

const searchSchema = z.object({ do: z.enum(["off", "stay"]).optional().catch(undefined) });

export const Route = createFileRoute("/admin/coaching/$periodId")({
  staticData: { crumb: { label: "Coaching mode", parents: [level("Users", "/admin/people")] } },
  validateSearch: (s) => searchSchema.parse(s),
  component: CoachingLinkPage,
});

function CoachingLinkPage() {
  return (
    <>
      <PageHeader title="Coaching mode" crumbs={<Crumbs />} />
      <Card className="max-w-[560px]">
        <div className="flex flex-col gap-3 px-4 py-4 text-ui">
          <p>Coaching mode is gone. Listen to your reps' calls from Live now.</p>
          <Link to="/admin/live-now" className="font-medium text-accent">
            Open Live now
          </Link>
        </div>
      </Card>
    </>
  );
}
